import { lazy, Suspense, useEffect, useRef, useState } from 'react';

const ContactForm = lazy(() => import('./ContactForm'));

function ContactFormFallback({ onLoad }) {
    return (
        <div className="contact-form contact-form-loading" aria-live="polite">
            <p>Загружаю форму…</p>
            <button className="button button-primary" type="button" onClick={onLoad}>Открыть форму</button>
        </div>
    );
}

function DeferredContactForm() {
    const containerRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container || !('IntersectionObserver' in window)) return undefined;

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;
            setShouldLoad(true);
            observer.disconnect();
        }, { rootMargin: '600px 0px' });
        observer.observe(container);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={containerRef} onFocusCapture={() => setShouldLoad(true)} onPointerDown={() => setShouldLoad(true)}>
            {shouldLoad ? (
                <Suspense fallback={<ContactFormFallback onLoad={() => setShouldLoad(true)} />}>
                    <ContactForm />
                </Suspense>
            ) : <ContactFormFallback onLoad={() => setShouldLoad(true)} />}
        </div>
    );
}

export default DeferredContactForm;
